import { useSearchParams } from 'react-router-dom'

export const usePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const currentPage = parseInt(searchParams.get('page') ?? '1')
  const limit = parseInt(searchParams.get('limit') ?? '20')

  const setCurrentPage = (page: number) => {
    setSearchParams(
      { ...Object.fromEntries(searchParams), page: page.toString() },
      { replace: true },
    )
  }

  return {
    currentPage,
    setCurrentPage,
    limit,
  }
}
